import React from 'react';
import { HiOutlinePencilAlt } from 'react-icons/hi';
import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';

const EmployeeRow = (props) => {

    const navigate = useNavigate();

    const handleClickRow = () => {
        navigate('/employee/detail/' + props.id);
    };

    return (
        <>
            {
                props.name ?
                <tr className={props.className} style={{cursor: "default"}}>
                    <td>{props.name}</td>
                    <td>{props.lastname}</td>
                    <td>{props.emailAddress}</td>
                    <td className='text-center'>
                        <a className='td-icon mx-1' style={{cursor: "pointer"}} onClick={handleClickRow} title={intl.get('roleRow.editButton.title')}>
                            <HiOutlinePencilAlt/>
                        </a>
                    </td>
                </tr> :
                null
            }
        </>
    )
}

export default EmployeeRow;
